export const TINYAI_CONSTANTS = {
  SWIPE_THRESHOLD: 30,
  KEYBOARD_DETECTION_RATIO: 0.75,
  TEXTAREA_LINE_HEIGHT: 24,
  TEXTAREA_MAX_LINES: 4,
  SCROLL_THRESHOLD: 50,
  KEYBOARD_FOCUS_DELAY: 300,
  KEYBOARD_BLUR_DELAY: 100,
} as const;
